export const getNumberOfFilters = (filteredFilters = []) => {
  return Object.keys(filteredFilters).reduce(
    (total, next) => total + filteredFilters[next].length,
    0
  );
};
